
















































import { mixins } from 'vue-class-component'
import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { Getter, State } from 'vuex-class'

import AppDialog from '@/components/AppDialog.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextSearchOrInput from '@/components/AppTextSearchOrInput.vue'
import AppPhoneInput from '@/components/AppPhoneInput.vue'
import RecordTypesHandler from '@/mixins/record-types'
import { Account } from '@/modules/Account/interfaces/account'
import { RecordType } from '@/modules/RecordType/interfaces/record-type'
import SearchAccount from '@/mixins/search-queries/search-account'
import { showErrors, showNotification } from '@/utils/snack'
import { newBusiness } from '@/modules/Case/gql/case.gql'
import { ApolloResponse } from '@/interfaces/apollo'
import { getCandidateAccounts } from '@/modules/Account/gql/account.gql'
import { SnackType } from '@/interfaces/snack'
import delNonNumCode from '@/utils/delNonNumCode'
import { User } from '@/modules/User/interfaces/user'

interface NewBusinessInput {
  account?: Account
  caseRecordType?: RecordType
  accountRecordType?: RecordType
  phone: string
  notes: string
  caseName: string
}

@Component({
  components: {
    AppDialog,
    AppTextarea,
    AppTextSearch,
    AppTextField,
    AppTextSearchOrInput,
    AppPhoneInput
  }
})

export default class NewBusinessDialog extends mixins(RecordTypesHandler, SearchAccount) {
  @Prop(Boolean) readonly value!: boolean

  newBusinessDialog = {
    show: false,
    disable: false
  }

  newBusinessInput: NewBusinessInput = {
    phone: '',
    caseName: '',
    notes: ''
  }

  candidatesAcctRt: RecordType[] = []
  candidatesCaseRt: RecordType[] = []
  acctRTypeIndex = 0
  caseRTypeIndex = 0

  @Getter('recordType/accountRecordTypes') acctRTypes!: RecordType[]
  @Getter('recordType/policyRecordTypes') caseRTypes!: RecordType[]
  @State(state => state.user.me) me!: User

  get candidatesAcctRTOptions () {
    return this.candidatesAcctRt.map(rt => {
      return {
        id: rt.id,
        name: rt.name
      }
    })
  }

  get candidatesCaseRTOptions () {
    return this.candidatesCaseRt.map(rt => {
      return {
        id: rt.id,
        name: rt.name
      }
    })
  }

  @Watch('allRecordTypes', { deep: true })
  onAllRecordTypesUpdated (val: RecordType[]) {
    this.candidatesAcctRt = this.acctRTypes
    this.candidatesCaseRt = this.caseRTypes
  }

  @Watch('value')
  valueChanged (val: boolean) {
    this.newBusinessDialog.show = val
  }

  @Watch('me')
  meChanged (val: User) {
    if (val) {
      this.getAllRecordTypes()
    }
  }

  @Emit('cancel')
  cancelDialog () {}

  showDialog () {
    this.newBusinessDialog.show = true
  }

  clearInput () {
    this.newBusinessInput = {
      phone: '',
      caseName: '',
      notes: ''
    }
    this.newBusinessDialog.disable = false
    this.cancelDialog()
  }

  getCandidateAcctRt (val: string) {
    if (!val) {
      this.candidatesAcctRt = this.acctRTypes
      return
    }
    this.candidatesAcctRt = this.acctRTypes.filter(rt => rt.name.toLowerCase().indexOf(val.toLowerCase()) !== -1)
  }

  getCandidateCaseRt (val: string) {
    if (!val) {
      this.candidatesCaseRt = this.caseRTypes
      return
    }
    this.candidatesCaseRt = this.caseRTypes.filter(rt => rt.name.toLowerCase().indexOf(val.toLowerCase()) !== -1)
  }

  selectAccountHandler (val: Account) {
    const selectedAcct = this.candidatesAccount.find(cAcct => cAcct.id === val.id)
    if (!selectedAcct) {
      return
    }
    this.newBusinessInput.phone = selectedAcct.phone
    this.newBusinessInput.account = selectedAcct
  }

  async getCandidateAccounts (val: string) {
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCandidateAccounts,
        variables: {
          filter: {
            name: val
          },
          paging: {
            offset: null,
            limit: -1
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.candidatesAccount = result.data.getAccounts.accounts
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  async newBusinessConfirm (ifRoute: boolean) {
    const { account, accountRecordType, caseRecordType, phone, notes } = this.newBusinessInput

    const newBusinessValid = (this.$refs.form as Vue & { validate: () => boolean }).validate()

    if (!newBusinessValid) {
      return
    }

    const { name: accountName, id: accountId } = (account as Account)
    const accountRecordTypeId = +(accountRecordType as RecordType).id
    const { name: caseRecordTypeName, id: caseRecordTypeId } = (caseRecordType as RecordType)

    this.newBusinessDialog.disable = true

    const phoneArr = phone.split(',')

    try {
      const res = await this.$apollo.mutate({
        mutation: newBusiness,
        variables: {
          input: {
            accountName,
            phone: delNonNumCode(phoneArr[1] || ''),
            extensionNumber: phoneArr[2] || '',
            countryCode: phoneArr[0] || '',
            countryCallingCode: phoneArr[3] || '',
            caseName: accountName + '-' + caseRecordTypeName + '-Case-New Business' + '-' + this.$moment.tz('America/New_York').year(),
            accountRecordTypeId: +accountRecordTypeId,
            caseRecordTypeId: +caseRecordTypeId,
            notes,
            accountId: +accountId
          }
        }
      })

      showNotification({
        msg: 'Fast creating new account and case successfully',
        type: SnackType.Success
      })

      this.clearInput()

      if (ifRoute) {
        const newCase = res.data.newBusiness
        this.$router.push({
          name: 'AccountDetailCase',
          params: {
            id: newCase.account.id
          }
        })
      }
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }
}
